<template>
  <b-card header="Gestor de tarifario">
    <b-row class="form-group">
      <b-col cols="12">
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Dirección</th>
                <th>Zona</th>
                <!-- <th>Distritos</th> -->
                <th>Servicio(s)</th>
                <th v-for="(tm, k) in truck_modes" :key="k">{{tm.name}}</th>
                <th>KM Reconocidos</th>
                <th>Galones reconocidos</th>
                <th>Accion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rate, z) in rates" :key="z">
                <td>
                  <!-- {{rate.company ? rate.company.name : ''}} -->
                  <select v-model="rate.company_id" class="form-control" v-if="rate.company_id" disabled>
                    <option v-for="(company, k) in companies" :key="k" :value="company.id">{{company.name}}</option>
                  </select>
                </td>
                <td>{{rate.company && rate.address ? rate.address.alias : ''}}</td>
                <td style="width: 10%;">
                  <select v-model="rate.zone_id" class="form-control" v-if="rate.zone_id" >
                    <option v-for="(zone, k) in zones" :key="k" :value="zone.id">{{zone.name}}</option>
                  </select>
                </td>
                <!-- <td>{{rate.zone ? rate.zone.places.map(p => p.name).join(', ') : ''}}</td> -->
                <td>
                  <h5 v-for="(rst, k) in rate.service_types" :key="k">
                    <span class="badge badge-secondary">{{rst.name}}</span>
                  </h5>
                  <!-- {{rate.service_types ? rate.service_types.map(s => s.name).join(', ') : ''}} -->
                </td>
                <td v-for="(tm, k) in truck_modes" :key="k">
                  <input type="text" class="form-control" v-model="rate.rate_modes[tm.id].price" v-if="rate.rate_modes[tm.id]"/>
                  <select v-model="rate.rate_modes[tm.id].currency_id" class="form-control" v-if="rate.rate_modes[tm.id]">
                    <option v-for="(currency, k) in currencies" :key="k" :value="currency.id">{{currency.code}}</option>
                  </select>
                </td>
                <td><input type="text" class="form-control" v-model="rate.kms"></td>
                <td><input type="text" class="form-control" v-model="rate.gallons"></td>
                <td>
                  <button class="btn btn-success btn-sm" @click="editRate(rate)"><i class="fa fa-save"/></button>&nbsp;
                  <button class="btn btn-danger btn-sm" @click="removeRates(rate.id)"><i class="fa fa-trash"/></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <select v-model="new_rate.company_id" class="form-control" @change="selectCompanyZone()" :disabled="disable_company">
                    <option value=''>Seleccione cliente</option>
                    <option v-for="(company, k) in companies" :key="k" :value="company.id">{{company.name}}</option>
                  </select>
                </td>
                <td>
                  <select v-model="new_rate.address_id" class="form-control" :disabled="disable_address">
                    <option value=''>Todas</option>
                    <option v-for="(address, k) in addresses" :key="k" :value="address.id">{{address.alias}}</option>
                  </select>
                </td>
                <td>
                  <select v-model="new_rate.zone_id" class="form-control" @change="selectCompanyZone()" :disabled="disable_zone">
                    <option value=''>Seleccione zona</option>
                    <option v-for="(zone, k) in zones" :key="k" :value="zone.id">{{zone.name}}</option>
                  </select>
                </td>
                <td>
                  <v-select multiple v-model="new_rate.service_types" label="name" :options="service_types"></v-select>
                </td>
                <td v-for="(tm, k) in truck_modes" :key="k">
                  <input type="text" class="form-control" v-model="new_rate.rate_modes[tm.id].price" v-if="new_rate.rate_modes[tm.id]"/>
                  <select v-model="new_rate.rate_modes[tm.id].currency_id" class="form-control" v-if="new_rate.rate_modes[tm.id]">
                    <option value="">Seleccione</option>
                    <option v-for="(currency, k) in currencies" :key="k" :value="currency.id">{{currency.code}}</option>
                  </select> 
                </td>
                <td>
                  <input type="text" v-model="new_rate.kms" class="form-control"/>
                </td>
                <td>
                  <input type="text" v-model="new_rate.gallons" class="form-control"/>
                </td>
                <td>
                  <button class="btn btn-success btn-sm" @click="addRate()">Guardar</button>
                </td>

              </tr>
            </tfoot>
          </table>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import api from '@/helpers/api'
export default {
  name: 'Rates',
  data(){
    return {
      new_rate: { 
        company_id: '',
        zone_id: '',
        rate_modes: {} 
      },
      rates: [{ 
        company_id: '',
        zone_id: '',
        rate_modes: {} 
      }],
      zones: [],
      companies: [],
      addresses: [],
      truck_modes: [],
      service_types: [],
      currencies: [],
      disable_company: false,
      disable_zone: false,
      disable_address: false
    }
  },
  mounted(){
    
    api.get('/truck_modes').then(response => {
      this.truck_modes = response.truck_modes
      this.truck_modes.map(tm => {
        this.new_rate.rate_modes[tm.id] = {}
        this.new_rate.rate_modes[tm.id].price = ''
        this.new_rate.rate_modes[tm.id].currency_id = ''
      })
    })

    api.get('/zones').then(response => {
      this.zones = response.zones
    })

    api.get('/currencies').then(response => {
      this.currencies = response.currencies
    })

    api.get('/companies').then(response => {
      this.companies = response.companies
    })

    api.get('/service_types').then(response => {
      this.service_types = response.service_types
    })

    api.get('/rates').then(response => {
      this.rates = response.rates
    })
  },
  methods: {
    addRate(){
      let data = this.new_rate

      // if(!data.company_id && !data.zone_id){
      //   this.$toastr.error('Debes indicar un cliente o zona', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
      //   return
      // }

      if(!data.service_types || !data.service_types.length){
        this.$toastr.error('Debes indicar al menos 1 servicio', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
        return
      }
      console.log(Object.values(data.rate_modes))
      let result = Object.values(data.rate_modes).some(rm => {
        return !rm.currency_id || !rm.price
      })

      if(result){
        this.$toastr.error('Todas las tarifas deben indicar monto y moneda.', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
        return
      }

      api.post('/rate', data).then(response => {
        this.rates.push(response.rate)
        
        // this.new_rate = { 
        //   company_id: '',
        //   zone_id: '',
        //   rate_modes: {} 
        // }

        this.$toastr.success('Tarifa creada.', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
      })
    },
    editRate(rate){
      api.put(`/rate/${rate.id}`, rate).then(response => {
        this.$toastr.success('Tarifa actualizada', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
      })
    },
    removeRates(id){
      if(confirm('¿Seguro desea eliminar la tarifa?')){
        api.delete(`/rate/${id}`).then(response => {
          let index = this.rates.findIndex(r => r.id === id)
          this.rates.splice(index, 1);
          this.$toastr.success('Tarifa eliminada', 'Tarifario', {positionClass: "toast-top-center", closeButton: true});
        })
      }
    },
    selectCompanyZone(){
      if(this.new_rate.company_id === '' && this.new_rate.zone_id === ''){
        this.disable_company = false
        this.disable_address = false
        this.disable_zone = false
      } else if(this.new_rate.zone_id > 0){
        this.disable_zone = false
        this.disable_company = true
        this.disable_address = true
        this.new_rate.company_id = ''
        this.new_rate.address_id = ''
      } else if(this.new_rate.company_id > 0){
        
        let company = this.companies.find(c => c.id === this.new_rate.company_id)
        this.addresses = company.addresses || []

        this.disable_zone = true
        this.disable_company = false
        this.disable_address = false
        this.new_rate.zone_id = ''
      }
    }
  }
}
</script>